import type { FunctionComponent } from 'react';

import { useFeatureFlag } from '@trello/feature-flag-client';

import type { FirstPartyAdsFlagValue } from './DiscoveryAdPowerUp';
import { LazyDiscoveryAdPowerUp } from './LazyDiscoveryAdPowerUp';

export const DiscoveryAdPowerUpContainer: FunctionComponent<{
  workspaceId: string;
}> = ({ workspaceId }) => {
  const is1PAdEnabled = ['message-1', 'message-2'].includes(
    useFeatureFlag<FirstPartyAdsFlagValue>(
      'xf.1p-ads-powerup-directory-free-users',
      'ne-control',
      { sendExposureEvent: true },
    ),
  );

  return is1PAdEnabled ? (
    <div className="directory-ad">
      <LazyDiscoveryAdPowerUp
        source={'boardDirectory'}
        workspaceId={workspaceId}
      />
    </div>
  ) : null;
};
